<template>
  <label class="estado" :class="[
      { [`estado-${label.toLowerCase()}`]: type },
    ]">
    {{ texto }}
  </label>
</template>
<script>
  export default {
    name: 'estado',
    props: {
      label: [String],
      type: {
        type: String,
        default: 'primary',
        description: 'Tipo Estado(primary|secondary|danger etc)'
      },
      // Texto con solo la primera letra en mayúscula («Sepa generado»), para
      // mostrar el estado fuera de las grids (fichas, formularios).
      capitalizado: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
      }
    },
    mounted(){
    },
    computed: {
      texto () {
        if (!this.capitalizado) return this.label.replace('_',' ').toUpperCase()
        const texto = this.label.replace(/_/g, ' ').toLowerCase()
        return texto.charAt(0).toUpperCase() + texto.slice(1)
      }
    },
    created () {
    }
  }
</script>

<style lang="scss" scoped>
.estado {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
}
</style>
